import { Percentage } from '@sparkdotfi/common-universal'

import { AccountSparkRewardsSummary } from '../types'
import { getChainConfigEntry } from '@/config/chain'
import { transformSimplifiedQueryResult } from '@/domain/common/query'
import { Token } from '@/domain/types/Token'
import { useOngoingCampaignsQuery } from '@/features/spark-rewards/data/useOngoingCampaignsQuery'
import { assets } from '@/ui/assets'

export interface UseSparkRewardsSummaryParams {
  chainId: number
  savingsToken: Token
}

export function useSparkRewardsSummary({
  chainId,
  savingsToken,
}: UseSparkRewardsSummaryParams): AccountSparkRewardsSummary {
  const ongoingCampaignsResult = useOngoingCampaignsQuery()
  const { tokenDefinitionRepository } = getChainConfigEntry(chainId)

  const { data } = transformSimplifiedQueryResult(ongoingCampaignsResult, (data) => {
    const campaigns = data
      .filter((campaign) => campaign.type === 'savings')
      .filter((campaign) => campaign.chainId === chainId)
      .filter((campaign) => campaign.savingsTokenSymbols.includes(savingsToken.symbol))

    const totalApy = campaigns.reduce((acc, campaign) => acc.plus(campaign.apy ?? 0), Percentage(0))

    const rewards = campaigns.map((campaign) => ({
      rewardTokenSymbol: campaign.rewardTokenSymbol,
      rewardTokenLogo: tokenDefinitionRepository.findBySymbol(campaign.rewardTokenSymbol)?.logo ?? assets.token.unknown,
      longDescription: campaign.longDescription,
    }))

    return { totalApy, rewards }
  })

  return data ?? { totalApy: Percentage(0), rewards: [] }
}
